import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import Store from "../../../containers/modules/master/store";

export default function StoreRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="store"
      index
      element={
        <AccessControl
          name={"Store List"}
          auth={authUser}
          component={() => <Store authUser={authUser} />}
        />
      }
    />
  );
}
